"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_1 = require("@nbc-design/modal");
require("./dialog.css");
const Header = ({ isCloseHidden, closeBtnAriaLabel }) => {
    return (0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { isCloseHidden: isCloseHidden, closeBtnAriaLabel: closeBtnAriaLabel });
};
exports.Header = Header;
//# sourceMappingURL=header.js.map